const DEFAULT_CLASS_CAPACITY = 4;

const SOF_CAPACITIES: Record<string, number> = {
  starfish: 4,
  seahorse: 4,
  seal: 6,
  barracuda: 8,
  swordfish: 8,
  dolphin: 8,
};

const ADULT_LEVELS = new Set(['beginner', 'technique', 'master']);
const FLYING_FISH_LEVELS = new Set([
  'development',
  'purple',
  'bronze',
  'silber',
  'gold',
]);

const normalize = (value: string | null | undefined): string =>
  (value || '').trim().toLowerCase().replace(/\s+/g, ' ');

export const getDefaultClassCapacity = (
  subtypeName: string | null | undefined,
  level: string | null | undefined,
): number => {
  const type = normalize(subtypeName);
  const normalizedLevel = normalize(level);

  if (type === 'sof') {
    return SOF_CAPACITIES[normalizedLevel] ?? DEFAULT_CLASS_CAPACITY;
  }

  if (
    (type === 'adult' || type.startsWith('adult ')) &&
    ADULT_LEVELS.has(normalizedLevel)
  ) {
    return 4;
  }

  if (type === 'flying fish' && FLYING_FISH_LEVELS.has(normalizedLevel)) {
    return 24;
  }

  return DEFAULT_CLASS_CAPACITY;
};

export { DEFAULT_CLASS_CAPACITY };
